// @ts-nocheck
import { removeCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import useIsomorphicLayoutEffect from "@store/Framework/Common/Hooks/useIsomorphicLayoutEffect";
import executeConditionally from "@store/Framework/Common/Utilities/executeConditionally";
import { CookieAttributes } from "js-cookie";

export const useHandleSetCookie = (
    name: string,
    value: string,
    options?: CookieAttributes,
    conditionalCallback?: () => boolean,
) => {
    useIsomorphicLayoutEffect(() => {
        executeConditionally(() => setCookie(name, value, options), conditionalCallback);
    }, []);
};

export const useHandleRemoveCookie = (
    name: string,
    options?: CookieAttributes,
    conditionalCallback?: () => boolean,
) => {
    useIsomorphicLayoutEffect(() => {
        executeConditionally(() => removeCookie(name, options), conditionalCallback);
    }, []);
};
